import type { ReactElement } from 'react';
import React from 'react';

import CardDialog from '~/components/CardDialog';
import ClaimLink from '~/components/ClaimLink';
import type { ClaimOwnerChangeClaimNotificationModel } from '~/components/ClaimNotificationsCard/types';
import Text from '~/components/core/TextComponents/Text';

import Caption from '../core/TextComponents/Caption';

interface ClaimOwnerChangedNotificationDisplayProps {
  onClose: () => void;
  notification: ClaimOwnerChangeClaimNotificationModel;
  AdditionalDialogHeader?: ReactElement;
}

const ClaimOwnerChangedNotificationDisplay: React.FC<ClaimOwnerChangedNotificationDisplayProps> = ({
  onClose,
  notification,
  AdditionalDialogHeader = <React.Fragment />,
}) => {
  // Render the backend-generated text so the detail dialog matches the notifications list,
  // and so consolidated FNOL notifications show the full claim + exposures wording.
  const fallbackText = `${!notification.exposure_id ? 'Claim' : 'Exposure'} owner updated to ${
    notification.recipient_sub_label
  }`;
  const displayText = notification.title || fallbackText;
  return (
    <CardDialog isDialog fullWidth maxWidth="sm" onClose={onClose} title="Ownership update">
      {AdditionalDialogHeader}
      <div className="grid grid-cols-1 gap-24">
        <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.MEDIUM}>
          {displayText}
        </Text>
        <div>
          <Caption variant={Caption.VARIANTS.LABEL} className="mb-4">
            Claim
          </Caption>
          {notification.claim_id && notification.claim_id_display && (
            <ClaimLink claimId={notification.claim_id} linkText={notification.claim_id_display} />
          )}
        </div>
      </div>
    </CardDialog>
  );
};

export default ClaimOwnerChangedNotificationDisplay;
